import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.css';
import Footer from '../Footer';

const ALL_IDS = [
  'preambulo', 's1', 's2', 's3', 's4', 's5', 's6', 's7',
  's8', 's9', 's10', 's11', 's12', 's13', 's14', 's15',
];

export default function TerminosCondiciones() {
  const { t, i18n } = useTranslation('terminos');
  const [activeId, setActiveId] = useState('preambulo');

  const sidebarItems = [
    { id: 'preambulo', label: t('sidebar.items.preambulo') },
    { id: 's1',  label: t('sidebar.items.s1') },
    { id: 's2',  label: t('sidebar.items.s2') },
    { id: 's3',  label: t('sidebar.items.s3') },
    { id: 's4',  label: t('sidebar.items.s4') },
    { id: 's5',  label: t('sidebar.items.s5') },
    { id: 's6',  label: t('sidebar.items.s6') },
    { id: 's7',  label: t('sidebar.items.s7') },
    { id: 's8',  label: t('sidebar.items.s8') },
    { id: 's9',  label: t('sidebar.items.s9') },
    { id: 's10', label: t('sidebar.items.s10') },
    { id: 's11', label: t('sidebar.items.s11') },
    { id: 's12', label: t('sidebar.items.s12') },
    { id: 's13', label: t('sidebar.items.s13') },
    { id: 's14', label: t('sidebar.items.s14') },
    { id: 's15', label: t('sidebar.items.s15') },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    document.title = t('meta.pageTitle');
    return () => {
      document.title = t('meta.defaultTitle');
    };
  }, [t]);

  useEffect(() => {
    const handleScroll = () => {
      let current = 'preambulo';
      ALL_IDS.forEach((id) => {
        const el = document.getElementById(id);
        if (el && el.getBoundingClientRect().top <= 120) current = id;
      });
      setActiveId(current);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const s1Items   = t('s1.items',   { returnObjects: true });
  const s2Items   = t('s2.items',   { returnObjects: true });
  const s3Items   = t('s3.items',   { returnObjects: true });
  const s4Rows    = t('s4.table.rows', { returnObjects: true });
  const s8Items   = t('s8.items',   { returnObjects: true });
  const s9Rows    = t('s9.table.rows', { returnObjects: true });
  const s10Items  = t('s10.items',  { returnObjects: true });
  const s12Items  = t('s12.items',  { returnObjects: true });
  const s15Contacts = t('s15.contacts', { returnObjects: true });

  const changeLang = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem('vox-lang', lang);
  };

  return (
    <>
      {/* NAV */}
      <nav className={styles.nav}>
        <a href="/" className={styles.navLogo}>
          <svg width="30" height="30" viewBox="0 0 40 40" fill="none">
            <rect width="40" height="40" rx="8" fill="#132d52" />
            <rect x="17" y="8" width="3" height="24" rx="1.5" fill="white" />
            <rect x="22" y="13" width="3" height="14" rx="1.5" fill="#5BA4CF" />
            <rect x="12" y="15" width="3" height="10" rx="1.5" fill="white" opacity=".7" />
          </svg>
          <span className={styles.navBrand}>Vox<span>Reports</span></span>
        </a>
        <div className={styles.navRight}>
          <a href="/" className={styles.navBack}>
            ← <span className={styles.navBackLabel}>{t('nav.back')}</span>
          </a>
          <div className={styles.navLangSwitch}>
            <button
              className={i18n.language === 'es' ? styles.navLangActive : undefined}
              onClick={() => changeLang('es')}
            >ES</button>
            <span>|</span>
            <button
              className={i18n.language === 'en' ? styles.navLangActive : undefined}
              onClick={() => changeLang('en')}
            >EN</button>
          </div>
          <a
            href="https://app.voxreports.com/login"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.navCta}
          >
            {t('nav.login')}
          </a>
        </div>
      </nav>

      {/* PAGE HEADER */}
      <div className={styles.pageHeader}>
        <div className={styles.headerInner}>
          <div className={styles.headerTag}>{t('header.tag')}</div>
          <h1 className={styles.pageTitle}>
            {t('header.titleLine1')}<br />
            {t('header.titleLine2')} <em>{t('header.titleEm')}</em>
          </h1>
          <div className={styles.headerMeta}>
            <div className={styles.metaPill}>
              <strong>{t('header.versionLabel')}</strong> {t('header.versionValue')}
            </div>
          </div>
        </div>
      </div>

      {/* PAGE BODY */}
      <div className={styles.pageBody}>

        {/* SIDEBAR */}
        <aside className={styles.sidebar}>
          <div className={styles.sidebarTitle}>{t('sidebar.title')}</div>
          <nav className={styles.sidebarNav}>
            {sidebarItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                className={
                  activeId === item.id
                    ? `${styles.sidebarLink} ${styles.sidebarLinkActive}`
                    : styles.sidebarLink
                }
              >
                {item.label}
              </a>
            ))}
          </nav>
        </aside>

        {/* CONTENT */}
        <main className={styles.content}>

          {/* PREÁMBULO */}
          <div className={styles.preambleBox} id="preambulo">
            <p>{t('preambulo.p1')}</p>
            <p>{t('preambulo.p2')}</p>
            <p>{t('preambulo.p3')}</p>
          </div>

          {/* 1 */}
          <div className={styles.sectionBlock} id="s1">
            <h2><span className={styles.sectionNum}>1</span>{t('s1.title')}</h2>
            <p>{t('s1.p1')}</p>
            <p>{t('s1.p2')}</p>
            <ul className={styles.termList}>
              {s1Items.map((item, i) => <li key={i}>{item}</li>)}
            </ul>
          </div>

          {/* 2 */}
          <div className={styles.sectionBlock} id="s2">
            <h2><span className={styles.sectionNum}>2</span>{t('s2.title')}</h2>
            <p>{t('s2.p1')}</p>
            <p>{t('s2.p2')}</p>
            <ul className={styles.termListAlpha}>
              {s2Items.map((item, i) => <li key={i}>{item}</li>)}
            </ul>
            <div className={`${styles.callout} ${styles.calloutWarn}`}>
              <span className={styles.calloutIcon}>⚠️</span>
              <span>{t('s2.warn')}</span>
            </div>
          </div>

          {/* 3 */}
          <div className={styles.sectionBlock} id="s3">
            <h2><span className={styles.sectionNum}>3</span>{t('s3.title')}</h2>
            <p>{t('s3.p1')}</p>
            <ul className={styles.termListAlpha}>
              {s3Items.map((item, i) => <li key={i}>{item}</li>)}
            </ul>
            <div className={`${styles.callout} ${styles.calloutWarn}`}>
              <span className={styles.calloutIcon}>⚠️</span>
              <span>{t('s3.warn')}</span>
            </div>
          </div>

          {/* 4 */}
          <div className={styles.sectionBlock} id="s4">
            <h2><span className={styles.sectionNum}>4</span>{t('s4.title')}</h2>
            <p>{t('s4.p1')}</p>
            <table className={styles.termTable}>
              <thead>
                <tr>
                  <th>{t('s4.table.headers.policy')}</th>
                  <th>{t('s4.table.headers.detail')}</th>
                </tr>
              </thead>
              <tbody>
                {s4Rows.map((row, i) => (
                  <tr key={i}>
                    <td><strong>{row.policy}</strong></td>
                    <td>{row.detail}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className={`${styles.callout} ${styles.calloutInfo}`}>
              <span className={styles.calloutIcon}>ℹ️</span>
              <span>{t('s4.info')}</span>
            </div>
          </div>

          {/* 5 */}
          <div className={styles.sectionBlock} id="s5">
            <h2><span className={styles.sectionNum}>5</span>{t('s5.title')}</h2>
            <div className={`${styles.callout} ${styles.calloutDark}`}>
              <span className={styles.calloutIcon}>💲</span>
              <div>
                <strong className={styles.priceTitle}>{t('s5.priceTitle')}</strong>
                {t('s5.priceDesc')}
              </div>
            </div>
            <h3>{t('s5.addVideoTitle')}</h3>
            <p>{t('s5.addVideoDesc')}</p>
            <h3>{t('s5.failedTitle')}</h3>
            <p>{t('s5.failedDesc')}</p>
            <h3>{t('s5.priceChangeTitle')}</h3>
            <p>{t('s5.priceChangeDesc')}</p>
          </div>

          {/* 6 */}
          <div className={styles.sectionBlock} id="s6">
            <h2><span className={styles.sectionNum}>6</span>{t('s6.title')}</h2>
            <h3>{t('s6.s61Title')}</h3>
            <p>{t('s6.s61p1')}</p>
            <p>{t('s6.s61p2')}</p>
            <h3>{t('s6.s62Title')}</h3>
            <p>{t('s6.s62p1')}</p>
            <h3>{t('s6.s63Title')}</h3>
            <p>{t('s6.s63p1')}</p>
            <h3>{t('s6.s64Title')}</h3>
            <p>{t('s6.s64p1')}</p>
            <h3>{t('s6.s65Title')}</h3>
            <p>{t('s6.s65p1')}</p>
          </div>

          {/* 7 */}
          <div className={styles.sectionBlock} id="s7">
            <h2><span className={styles.sectionNum}>7</span>{t('s7.title')}</h2>
            <h3>{t('s7.s71Title')}</h3>
            <p>{t('s7.s71p1')}</p>
            <div className={`${styles.callout} ${styles.calloutInfo}`}>
              <span className={styles.calloutIcon}>ℹ️</span>
              <span>{t('s7.s71info')}</span>
            </div>
            <h3>{t('s7.s72Title')}</h3>
            <p>{t('s7.s72p1')}</p>
            <h3>{t('s7.s73Title')}</h3>
            <p>{t('s7.s73p1')}</p>
            <h3>{t('s7.s74Title')}</h3>
            <p>{t('s7.s74p1')}</p>
          </div>

          {/* 8 */}
          <div className={styles.sectionBlock} id="s8">
            <h2><span className={styles.sectionNum}>8</span>{t('s8.title')}</h2>
            <p>{t('s8.p1')}</p>
            <ul className={styles.termList}>
              {s8Items.map((item, i) => <li key={i}>{item}</li>)}
            </ul>
            <div className={`${styles.callout} ${styles.calloutInfo}`}>
              <span className={styles.calloutIcon}>ℹ️</span>
              <span>{t('s8.info')}</span>
            </div>
          </div>

          {/* 9 */}
          <div className={styles.sectionBlock} id="s9">
            <h2><span className={styles.sectionNum}>9</span>{t('s9.title')}</h2>
            <p>{t('s9.p1')}</p>
            <table className={styles.termTable}>
              <thead>
                <tr>
                  <th>{t('s9.table.headers.criteria')}</th>
                  <th>{t('s9.table.headers.condition')}</th>
                  <th>{t('s9.table.headers.result')}</th>
                </tr>
              </thead>
              <tbody>
                {s9Rows.map((row, i) => (
                  <tr key={i}>
                    <td><strong>{row.criteria}</strong></td>
                    <td>{row.condition}</td>
                    <td>{row.result}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <p>{t('s9.p2')}</p>
          </div>

          {/* 10 */}
          <div className={styles.sectionBlock} id="s10">
            <h2><span className={styles.sectionNum}>10</span>{t('s10.title')}</h2>
            <p>{t('s10.p1')}</p>
            <p>{t('s10.p2')}</p>
            <ul className={styles.termListAlpha}>
              {s10Items.map((item, i) => <li key={i}>{item}</li>)}
            </ul>
            <div className={`${styles.callout} ${styles.calloutInfo}`}>
              <span className={styles.calloutIcon}>🔒</span>
              <span>{t('s10.info')}</span>
            </div>
            <p>{t('s10.p3')}</p>
          </div>

          {/* 11 */}
          <div className={styles.sectionBlock} id="s11">
            <h2><span className={styles.sectionNum}>11</span>{t('s11.title')}</h2>
            <p>{t('s11.p1')}</p>
            <p>{t('s11.p2')}</p>
            <div className={`${styles.callout} ${styles.calloutWarn}`}>
              <span className={styles.calloutIcon}>⚠️</span>
              <span>{t('s11.warn')}</span>
            </div>
          </div>

          {/* 12 */}
          <div className={styles.sectionBlock} id="s12">
            <h2><span className={styles.sectionNum}>12</span>{t('s12.title')}</h2>
            <p>{t('s12.p1')}</p>
            <ul className={styles.termListAlpha}>
              {s12Items.map((item, i) => <li key={i}>{item}</li>)}
            </ul>
            <div className={`${styles.callout} ${styles.calloutInfo}`}>
              <span className={styles.calloutIcon}>📦</span>
              <span>{t('s12.info')}</span>
            </div>
          </div>

          {/* 13 */}
          <div className={styles.sectionBlock} id="s13">
            <h2><span className={styles.sectionNum}>13</span>{t('s13.title')}</h2>
            <p>{t('s13.p1')}</p>
            <p>{t('s13.p2')}</p>
            <p>{t('s13.p3')}</p>
            <p>{t('s13.p4')}</p>
          </div>

          {/* 14 */}
          <div className={styles.sectionBlock} id="s14">
            <h2><span className={styles.sectionNum}>14</span>{t('s14.title')}</h2>
            <p>{t('s14.p1')}</p>
            <p>{t('s14.p2')}</p>
            <p>{t('s14.p3')}</p>
            <p>{t('s14.p4')}</p>
          </div>

          {/* 15 */}
          <div className={styles.sectionBlock} id="s15">
            <h2><span className={styles.sectionNum}>15</span>{t('s15.title')}</h2>
            <p>{t('s15.p1')}</p>
            <div className={styles.contactGrid}>
              {s15Contacts.map((contact, i) => (
                <div key={i} className={styles.contactCard}>
                  <div className={styles.contactCardLabel}>{contact.label}</div>
                  <a href={contact.url}>{contact.display}</a>
                </div>
              ))}
            </div>
            <div
              className={`${styles.callout} ${styles.calloutDark}`}
              style={{ marginTop: '24px' }}
            >
              <span className={styles.calloutIcon}>✓</span>
              <span>
                {t('s15.closing')}{' '}
                <strong style={{ color: 'var(--blue-light)' }}>{t('s15.version')}</strong>
              </span>
            </div>
          </div>

        </main>
      </div>

      <Footer />
    </>
  );
}
